export const DEFAULT_MAX_DISTANCE_MILES = 50;
export const NATIONWIDE_MAX_DISTANCE_MILES = 2500;

export function resolveMaxDistanceMiles(maxDistanceMiles?: number) {
    return maxDistanceMiles && maxDistanceMiles > 0
        ? maxDistanceMiles
        : DEFAULT_MAX_DISTANCE_MILES;
}
